import React, { useCallback } from 'react'
import { Link, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles({
  text: {
    fontSize: 14,
    cursor: 'pointer',
    textAlign: 'center',
    color: mutualTheme.palette.blue.main
  },
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: mutualTheme.spacing(1),
    [mutualTheme.breakpoints.down('md')]: {
      maxWidth: 300
    }
  }
})

export const Footer: React.FC = () => {
  const classes = useStyles()
  const history = useHistory()

  const onLoginPress = useCallback(() => {
    history.replace('/')
  }, [history])

  return (
    <Box className={classes.container}>
      <Link onClick={() => onLoginPress()} className={classes.text}>Já solicitou seu empréstimo? Faça seu login para acompanhar o andamento</Link>
    </Box>
  )
}
